/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mvp_Sprint_Work_0_BadgeInputs */

const en_svc_mvp_sprint_work_0_badge = /** @type {(inputs: Svc_Mvp_Sprint_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zero-to-shipped product`)
};

const ar_svc_mvp_sprint_work_0_badge = /** @type {(inputs: Svc_Mvp_Sprint_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منتج مطلق من الصفر`)
};

const bn_svc_mvp_sprint_work_0_badge = /** @type {(inputs: Svc_Mvp_Sprint_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`শূন্য থেকে লঞ্চ করা প্রোডাক্ট`)
};

const de_svc_mvp_sprint_work_0_badge = /** @type {(inputs: Svc_Mvp_Sprint_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produkt von null auf live`)
};

const es_svc_mvp_sprint_work_0_badge = /** @type {(inputs: Svc_Mvp_Sprint_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Producto lanzado desde cero`)
};

const fr_svc_mvp_sprint_work_0_badge = /** @type {(inputs: Svc_Mvp_Sprint_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produit lancé depuis zéro`)
};

const pt_svc_mvp_sprint_work_0_badge = /** @type {(inputs: Svc_Mvp_Sprint_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produto lançado do zero`)
};

const zh_svc_mvp_sprint_work_0_badge = /** @type {(inputs: Svc_Mvp_Sprint_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从零到上线的产品`)
};

const tr_svc_mvp_sprint_work_0_badge = /** @type {(inputs: Svc_Mvp_Sprint_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sıfırdan yayına ürün`)
};

const ru_svc_mvp_sprint_work_0_badge = /** @type {(inputs: Svc_Mvp_Sprint_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продукт с нуля до запуска`)
};

const pl_svc_mvp_sprint_work_0_badge = /** @type {(inputs: Svc_Mvp_Sprint_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produkt wypuszczony od zera`)
};

/**
* | output |
* | --- |
* | "Zero-to-shipped product" |
*
* @param {Svc_Mvp_Sprint_Work_0_BadgeInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mvp_sprint_work_0_badge = /** @type {((inputs?: Svc_Mvp_Sprint_Work_0_BadgeInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mvp_Sprint_Work_0_BadgeInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mvp_sprint_work_0_badge(inputs)
	if (locale === "bn") return bn_svc_mvp_sprint_work_0_badge(inputs)
	if (locale === "de") return de_svc_mvp_sprint_work_0_badge(inputs)
	if (locale === "es") return es_svc_mvp_sprint_work_0_badge(inputs)
	if (locale === "fr") return fr_svc_mvp_sprint_work_0_badge(inputs)
	if (locale === "pt") return pt_svc_mvp_sprint_work_0_badge(inputs)
	if (locale === "zh") return zh_svc_mvp_sprint_work_0_badge(inputs)
	if (locale === "tr") return tr_svc_mvp_sprint_work_0_badge(inputs)
	if (locale === "ru") return ru_svc_mvp_sprint_work_0_badge(inputs)
	if (locale === "pl") return pl_svc_mvp_sprint_work_0_badge(inputs)
	return en_svc_mvp_sprint_work_0_badge(inputs)
});
export { svc_mvp_sprint_work_0_badge as "svc_mvp-sprint_work_0_badge" }